export { EnergyLabel } from './EnergyLabel';
